import React, { useState } from 'react';
import queryString from 'query-string';
import locales from '../../../translations';

export const LocalContext = React.createContext(locales.en);

export const withLocal = Component => props => (
  <LocalContext.Consumer>
    {value => (
      <Component {...props} locale={value.locale} setLocale={value.setLocale} />
    )}
  </LocalContext.Consumer>
);

export default ({ children }) => {
  const { l: queryLocale } = queryString.parse(window.location.search);

  const [locale, setLocale] = useState(locales[queryLocale] || locales.en);

  const value = { locale, setLocale: id => setLocale(locales[id]) };

  return (
    <LocalContext.Provider value={value}>{children}</LocalContext.Provider>
  );
};
